<div class="post-cards-tools {{ toolsClass }}">
  @if (
    userFacade.hasPermissionSync(
      AppComponents.FEED_SEARCH_RESULTS_ITEMS_PER_PAGE
    )
  ) {
    <div class="items-per-page">
      @if (itemsPerPage$ | async; as itemsPerPage) {
        <sui-select
          [ngModel]="itemsPerPage"
          (ngModelChange)="onItemsPerPageChange($event)"
        >
          @for (option of itemsPerPageOptions; track option) {
            <sui-select-option [value]="option">{{ option }}</sui-select-option>
          }
        </sui-select>
      }
      <div class="total-count">
        from
        <span class="bold">{{ totalItemsCount$ | async | number }}</span>
        total
      </div>
    </div>
  }
  @if (paginationData$ | async; as data) {
    <div class="pagination-holder">
      <sui-pagination
        [pageSize]="data.pageSize"
        [currentPage]="data.page"
        [collectionSize]="data.collectionSize"
        (pageChanged)="pageChanged($event)"
        (doPageChange)="doPageChange($event)"
      ></sui-pagination>
    </div>
  }
</div>
